(function () {
  function syncPriceFromSource(priceSource, stickyPrice) {
    if (!priceSource || !stickyPrice) return;
    stickyPrice.innerHTML = priceSource.innerHTML;
  }

  function primaryLabelText(mainBtn) {
    const soldOut = mainBtn.querySelector('.sold-out-message');
    if (soldOut && !soldOut.classList.contains('hidden')) {
      return soldOut.textContent.trim();
    }
    const textSpan = mainBtn.querySelector('span:not(.loading__spinner)');
    return textSpan ? textSpan.textContent.trim() : '';
  }

  function syncStickyButton(mainBtn, stickyBtn, stickyLabel) {
    stickyBtn.disabled = mainBtn.disabled;
    const ariaDisabled = mainBtn.getAttribute('aria-disabled');
    if (ariaDisabled === 'true') {
      stickyBtn.setAttribute('aria-disabled', 'true');
    } else {
      stickyBtn.removeAttribute('aria-disabled');
    }

    if (stickyLabel) {
      const t = primaryLabelText(mainBtn);
      if (t) stickyLabel.textContent = t;
    }

    stickyBtn.classList.toggle('loading', mainBtn.classList.contains('loading'));

    const mainSpinner = mainBtn.querySelector('.loading__spinner');
    const stickySpinner = stickyBtn.querySelector('.loading__spinner');
    if (mainSpinner && stickySpinner) {
      stickySpinner.classList.toggle('hidden', mainSpinner.classList.contains('hidden'));
    }
  }

  function initStickyAtc(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    const mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    const priceSource = document.getElementById('price-' + sectionId);
    const stickyBtn = root.querySelector('[data-sticky-atc-btn]');
    const stickyLabel = root.querySelector('[data-sticky-atc-label]');
    const stickyPrice = root.querySelector('[data-sticky-atc-price]');

    if (!mainBtn || !stickyBtn) {
      root.remove();
      return;
    }

    const runSync = () => {
      syncPriceFromSource(priceSource, stickyPrice);
      syncStickyButton(mainBtn, stickyBtn, stickyLabel);
    };

    runSync();

    const mo = new MutationObserver(() => syncStickyButton(mainBtn, stickyBtn, stickyLabel));
    mo.observe(mainBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event || !event.data || String(event.data.sectionId) !== String(sectionId)) return;
        requestAnimationFrame(runSync);
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'product-form') {
          requestAnimationFrame(() => syncStickyButton(mainBtn, stickyBtn, stickyLabel));
        }
      });
    }

    stickyBtn.addEventListener('click', () => {
      if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
      mainBtn.click();
    });

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((e) => e.isIntersecting);
        root.classList.toggle('product-sticky-atc--hidden', visible);
      },
      { root: null, rootMargin: '0px 0px -12px 0px', threshold: 0 }
    );
    io.observe(mainBtn);
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
